import { Details } from '../../../../../types/BillOfMaterial';
import React, { useState } from 'react';
import { Table, TableColumnsType, TableProps } from 'antd';
import { roundAndFormat } from '../../../../../lib/utils';

type OnChange = NonNullable<TableProps<Details>['onChange']>;

type Filters = Parameters<OnChange>[1];

interface BillOfMaterialInfoTableProps {
  data?: Details[];
}
const BillOfMaterialInfoTable: React.FC<BillOfMaterialInfoTableProps> = ({
  data,
}) => {
  const [filteredInfo, setFilteredInfo] = useState<Filters>({});
  const sortedData = data
    ?.slice()
    .sort(
      (a, b) =>
        a.processGroup.localeCompare(b.processGroup) ||
        a.product?.code.localeCompare(b.product?.code),
    );

  const handleChange: OnChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
  };

  const uniqueProcessGroups = Array.from(
    new Set(
      data
        // ?.filter((f) => {
        //   return (
        //     (!filteredInfo.sku || filteredInfo.sku.includes(f.sku)) &&
        //     (!filteredInfo.processGroup ||
        //       filteredInfo.processGroup.includes(f.processGroup)) &&
        //     (!filteredInfo.productCode ||
        //       filteredInfo.productCode.includes(f.product?.code))
        //   );
        // })
        ?.map((item) => item.processGroup),
    ),
  );
  const uniqueSKU = Array.from(
    new Set(
      data
        // ?.filter((f) => {
        //   return (
        //     (!filteredInfo.sku || filteredInfo.sku.includes(f.sku)) &&
        //     (!filteredInfo.processGroup ||
        //       filteredInfo.processGroup.includes(f.processGroup)) &&
        //     (!filteredInfo.productCode ||
        //       filteredInfo.productCode.includes(f.product?.code))
        //   );
        // })
        ?.map((item) => item.sku),
    ),
  );
  const uniqueProductCode = Array.from(
    new Set(
      data
        // ?.filter((f) => {
        //   return (
        //     (!filteredInfo.sku || filteredInfo.sku.includes(f.sku)) &&
        //     (!filteredInfo.processGroup ||
        //       filteredInfo.processGroup.includes(f.processGroup)) &&
        //     (!filteredInfo.productCode ||
        //       filteredInfo.productCode.includes(f.product?.code))
        //   );
        // })
        ?.map((item) => item.product?.code),
    ),
  );

  const columns: TableColumnsType<Details> = [
    {
      title: 'Process Group',
      dataIndex: 'processGroup',
      filters: uniqueProcessGroups.map((group) => ({
        text: group,
        value: group,
      })),
      onFilter: (value, record) => {
        return (
          (!filteredInfo.productCode ||
            record.product?.code === filteredInfo.productCode.toString()) &&
          (!filteredInfo.sku || record.sku === filteredInfo.sku.toString()) &&
          (!filteredInfo.processGroup || record.processGroup === value)
        );
      },
    },
    {
      title: 'Product Code',
      dataIndex: 'productCode',
      filterSearch: true,
      render: (value, record) => (
        <span>{record.product?.code ?? record.materialCode}</span>
      ),
      filters: uniqueProductCode.map((group) => ({
        text: group,
        value: group,
      })),
      onFilter: (value, record) => {
        return record.product?.code?.includes(value as string);
      },
    },
    {
      title: 'Product',
      dataIndex: 'product',
      render: (value, record) => (
        <span>{record.product?.description ?? record.materialName}</span>
      ),
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      render: (value, record) => (
        <span>{roundAndFormat(record.quantity, 100000, 5)}</span>
      ),
    },
    {
      title: 'UoM',
      dataIndex: 'uom',
      render: (value, record) => (
        <span>{record.defaultUom?.description ?? record.unit}</span>
      ),
    },
    {
      title: 'SKU',
      dataIndex: 'sku',
      filterSearch: true,
      filters: uniqueSKU.map((group) => ({
        text: group,
        value: group,
      })),
      onFilter: (value, record) => {
        return record.sku.includes(value as string);
      },
    },
    {
      title: 'Packing No',
      dataIndex: 'setPackingNo',
    },
    {
      title: 'Size',
      dataIndex: 'size',
    },
    {
      title: 'Brand',
      dataIndex: 'brand',
    },
  ];
  return (
    <>
      <Table
        rowKey={(record) => record.id}
        columns={columns}
        dataSource={sortedData}
        onChange={handleChange}
        pagination={{
          showSizeChanger: true,
          defaultPageSize: 100,
          pageSize: 100,
          pageSizeOptions: ['10', '20', '50', '100'],
        }}
      />
      {/*<Table*/}
      {/*  onChange={handleChange}*/}
      {/*  rowKey={(record) => record.id}*/}
      {/*  dataSource={sortedData}*/}
      {/*  pagination={{*/}
      {/*    showSizeChanger: true,*/}
      {/*    pageSizeOptions: ['10', '20', '50', '100'],*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <Table.Column*/}
      {/*    title="Process Group"*/}
      {/*    dataIndex="processGroup"*/}
      {/*    sorter={(a: Details, b) =>*/}
      {/*      a.processGroup.localeCompare(b.processGroup)*/}
      {/*    }*/}
      {/*    filters={[*/}
      {/*      { text: 'Attachment', value: 'Attachment' },*/}
      {/*      { text: 'Packing Materials', value: 'Packing Materials' },*/}
      {/*    ]}*/}
      {/*    filteredValue={filteredInfo.name || null}*/}
      {/*    onFilter={(value, record: Details) =>*/}
      {/*      record.processGroup.includes(value as string)*/}
      {/*    }*/}
      {/*    render={(processGroup, record: Details) => {*/}
      {/*      return (*/}
      {/*        <span className={'font-semibold'}>{record.processGroup}</span>*/}
      {/*      );*/}
      {/*    }}*/}
      {/*  />*/}

      {/*  <Table.Column*/}
      {/*    title="Product Code"*/}
      {/*    dataIndex="productCode"*/}
      {/*    render={(product, record: Details) => {*/}
      {/*      return <span>{record.product?.code}</span>;*/}
      {/*    }}*/}
      {/*  />*/}
      {/*  <Table.Column*/}
      {/*    title="Product"*/}
      {/*    dataIndex="product"*/}
      {/*    render={(product, record: Details) => {*/}
      {/*      return <span>{record.product?.description}</span>;*/}
      {/*    }}*/}
      {/*  />*/}
      {/*  <Table.Column*/}
      {/*    title="Quantity"*/}
      {/*    dataIndex="quantity"*/}
      {/*    render={(_text: string, record: Details) =>*/}
      {/*      roundAndFormat(record.quantity)*/}
      {/*    }*/}
      {/*  />*/}
      {/*  <Table.Column*/}
      {/*    title="UoM"*/}
      {/*    dataIndex="uom"*/}
      {/*    render={(product, record: Details) => {*/}
      {/*      return <span>{record.purchaseUom?.description}</span>;*/}
      {/*    }}*/}
      {/*  />*/}
      {/*  <Table.Column title="SKU" dataIndex="sku" />*/}
      {/*  <Table.Column title="Packing No" dataIndex="setPackingNo" />*/}
      {/*  <Table.Column title="Size" dataIndex="size" />*/}
      {/*  <Table.Column title="Brand" dataIndex="brand" />*/}
      {/*</Table>*/}
    </>
  );
};

export default BillOfMaterialInfoTable;
